var map = {
	"./en/bulkRequest.json": 35,
	"./en/common.json": 251,
	"./en/partyRequest.json": 955,
	"./en/patient.json": 835,
	"./en/patientDetails.json": 811,
	"./en/patientDetailsFMLS.json": 879,
	"./en/requirnment.json": 232,
	"./en/singleRequest.json": 471,
	"./en/welcome.json": 626,
	"./es/bulkRequest.json": 88,
	"./es/common.json": 266,
	"./es/partyRequest.json": 738,
	"./es/patient.json": 720,
	"./es/patientDetails.json": 466,
	"./es/patientDetailsFMLS.json": 794,
	"./es/requirnment.json": 683,
	"./es/singleRequest.json": 704,
	"./es/welcome.json": 273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 175;